import data from "../../.sourceflow/simple_pages.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const simple_pages_helper = new CollectionHelper(data);
